/* https://www.youtube.com/watch?v=-NI5e_GTIko */
import React, { useState, useEffect, useContext } from 'react';
import { UmbracoContext } from 'contexts/Umbraco';

import GoogleMapReact from 'google-map-react';
import { RiCloseFill, RiZoomOutLine } from 'react-icons/ri';
import { CgArrowsExpandUpRight } from 'react-icons/cg';

// SVG imports
import { ReactComponent as IconDefaultYellow } from '../bg-icons/Ikon-kart-default-gult.svg';
import { ReactComponent as IconDefaultRed } from '../bg-icons/Ikon-kart-default-rødt.svg';

// USE API_KEY for production, use empty string API_KEY for localhost development
let API_KEY = 'AIzaSyD-GoO7FMIe9bFezmLtHng0L8IPeScpY-Q';
//API_KEY = '';

export default function GMapV5({
	markers,
	hoveredMenuItem,
	activeItem,
	onChildClick,
	resetMapView,
	view,
	showingEntireMap,
	setShowingEntireMap,
	infoBoxOpen,
	openInfoBox,
}) {
	let projectsWithCoordinates = markers?.filter(
		(el) => el.lat !== null && el.lng !== null
	);

	const Marker = ({ text, item, highlighted }) => {
		const { isTouch } = useContext(UmbracoContext);

		const [isActive, setIsActive] = useState(false);
		useEffect(() => {
			if (item && activeItem && activeItem.id === item.id) {
				setIsActive(true);
			}
		}, [item]);
		return (
			<div
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					if (isTouch) {
						onChildClick(item);
					}
				}}
				onMouseDown={(e) => {
					e.preventDefault();
					e.stopPropagation();
					if (!isTouch) {
						onChildClick(item);
					}
				}}
				className={`gmap__marker ${isActive ? 'gmap__marker--active' : ''}
							${item.disabled ? 'gmap__marker--missing-data' : ''}
							
					`}
				style={
					highlighted
						? {
								backgroundColor: '#fff',
								zIndex: 1,
								transform: 'translate(-50%, -50%) scale(1.2)',
						  }
						: {}
				}>
				{item.type === 'reference' ? <IconDefaultRed /> : <IconDefaultYellow />}
				<div
					style={highlighted ? { opacity: 1 } : {}}
					className='gmap__marker__tooltip'>
					{isActive && (
						<div
							className='gmap__marker__tooltip__close'
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								if (isTouch) {
									onChildClick(item);
								}
							}}
							onMouseDown={(e) => {
								e.preventDefault();
								e.stopPropagation();
								if (!isTouch) {
									onChildClick(item);
								}
							}}>
							<RiCloseFill size='1rem' />
						</div>
					)}
					<p className='mb-0 gmap__marker__tooltip__text'>{text}</p>
					{isActive && !item.disabled && (
						<>
							<div
								className={`btn ${
									item.disabled ? 'btn-disabled' : 'btn-info'
								} rounded-sm`}
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									isTouch && openInfoBox(true);
								}}
								onMouseDown={(e) => {
									e.preventDefault();
									e.stopPropagation();
									!isTouch && openInfoBox(true);
								}}>
								<a
									onClick={() => {
										window.open(item.url, '_self');
									}}
									onMouseDown={() => {
										window.open(item.url, '_self');
									}}
									href={item.url}
									className={`map-marker-link ${
										item.type === 'active'
											? 'map-marker-hover-yellow'
											: 'map-marker-hover-red'
									}`}
									rel='noopener noreferrer'>
									Se detaljer <CgArrowsExpandUpRight />{' '}
								</a>
							</div>
						</>
					)}
					{item.disabled && (
						<small style={{ color: 'grey' }}>(Mangler data)</small>
					)}
				</div>
			</div>
		);
	};

	const getMapBounds = (map, maps, locations) => {
		const bounds = new maps.LatLngBounds();

		locations.forEach((loc) => {
			bounds.extend(new maps.LatLng(parseFloat(loc.lat), parseFloat(loc.lng)));
		});
		return bounds;
	};

	const bindResizeListener = (map, maps, bounds) => {
		maps.event.addDomListenerOnce(map, 'idle', () => {
			maps.event.addDomListener(window, 'resize', () => {
				map.fitBounds(bounds);
			});
		});
	};

	const fitAll = React.useCallback(
		(map, maps, locations) => {
			setShowingEntireMap(true);
			if (map && maps && locations) {
				const bounds = getMapBounds(map, maps, locations);
				map.fitBounds(bounds, 40);
				bindResizeListener(map, maps, bounds);
			}
		},
		[setShowingEntireMap]
	);

	// Set map data on load
	const [loadedProps, setLoadedProps] = useState(null);
	const defaultCenter = {
		lat: 63.460675,
		lng: 10.880635,
	};
	const defaultZoom = 5;

	const updateShowingEntireMap = React.useCallback(
		(val) => {
			setShowingEntireMap(val);
		},
		[setShowingEntireMap]
	);
	useEffect(() => {
		if (loadedProps) {
			if (activeItem && activeItem.lat && activeItem.lng) {
				// // fitAll(loadedProps.map, loadedProps.maps, [
				// //     {
				// //         lat: parseFloat(activeItem.lat),
				// //         lng: parseFloat(activeItem.lng),
				// //     },
				// // ]);
				updateShowingEntireMap(false);
				loadedProps.map.panTo({
					lat: parseFloat(activeItem.lat),
					lng: parseFloat(activeItem.lng),
				});
				loadedProps.map.setZoom(9);
			} else {
				// loadedProps.map.panTo(mapDefaults.center);
				// loadedProps?.map?.panToBounds(defaultBounds, 100);
				// fitAll(
				//     loadedProps.map,
				//     loadedProps.maps,
				//     markersWithCoordinates
				// );
			}
		}
	}, [activeItem, loadedProps, updateShowingEntireMap]);

	useEffect(() => {
		if (resetMapView && projectsWithCoordinates) {
			// loadedProps.map.panTo(mapDefaults.center);
			fitAll(loadedProps.map, loadedProps.maps, projectsWithCoordinates);
		}
	}, [resetMapView, loadedProps, projectsWithCoordinates, fitAll]);
	const [mapOptions, setMapOptions] = useState({});
	function getMapOptions(maps) {
		return {
			disableDefaultUI: true,
			fullscreenControl: false,
			zoomControlOptions: {
				position: maps.ControlPosition.RIGHT_TOP,
			},
			//	styles: require(`./style-3.json`), // use this to import custom map styles. use snazzymaps
			gestureHandling: 'greedy',
		};
	}
	return (
		<>
			{!showingEntireMap &&
				view === 'harbours' &&
				!infoBoxOpen &&
				projectsWithCoordinates && (
					<span
						className='btn btn-info gmap__reset-map-btn'
						onClick={() =>
							fitAll(loadedProps.map, loadedProps.maps, projectsWithCoordinates)
						}>
						<RiZoomOutLine /> Vis hele kartet
					</span>
				)}
			<div
				style={{
					height: '100vh',
					width: '100%',
				}}>
				<GoogleMapReact
					options={mapOptions}
					containerElement={
						<div
							style={{
								width: '100%',
								marginLeft: 0,
							}}
						/>
					}
					defaultCenter={defaultCenter}
					defaultZoom={defaultZoom}
					bootstrapURLKeys={{
						key: API_KEY,
						libraries: ['visualization'],
					}}
					yesIWantToUseGoogleMapApiInternals
					onGoogleApiLoaded={({ map, maps }) => {
						// setMapDefaults({
						//     center: map.getCenter(),
						//     zoom: map.getZoom(),
						// });
						setMapOptions(() => getMapOptions(maps));
						setLoadedProps({ map, maps });
						fitAll(map, maps, projectsWithCoordinates);
					}}>
					{projectsWithCoordinates?.map((marker) => (
						<Marker
							lat={marker.lat}
							lng={marker.lng}
							item={marker}
							highlighted={
								hoveredMenuItem === marker.name ||
								activeItem?.name === marker.name
							}
							key={`${marker.name}-marker`}
							text={marker.name}
						/>
					))}
				</GoogleMapReact>
			</div>
		</>
	);
}
